/**
 * Format a date string as relative time (e.g., "2s", "5m", "3h", "2d", "Jan 15")
 */
export function formatRelativeTime(isoDate: string): string {
    const now = Date.now()
    const date = new Date(isoDate).getTime()

    if (isNaN(date)) return ''

    const diffMs = now - date
    if (diffMs < 0) return 'just now'

    const diffSec = Math.floor(diffMs / 1000)
    const diffMin = Math.floor(diffSec / 60)
    const diffHour = Math.floor(diffMin / 60)
    const diffDay = Math.floor(diffHour / 24)

    if (diffSec < 60) return `${Math.max(0, diffSec)}s`
    if (diffMin < 60) return `${diffMin}m`
    if (diffHour < 24) return `${diffHour}h`
    if (diffDay < 7) return `${diffDay}d`

    return new Date(isoDate).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
    })
}
